import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import EsignComponent from './EsignComponent';
import { accOpeningActions, localStateManagementActions } from '../../../shared/Actions';
import withAccountManagement from '../AccountManagementHOC';

const mapStateToProps = (state /* , props */) => ({
    masterLookupStateData: state.masterLookUpData,
    localStateData: state.localStateManagementReducerData,
    accOpeningData: state.accOpeningReducerData,
    tradingWindowData: state.tradingWindowData,
    profileInformationData: state.profileInformationData,
    purchaseReducerData: state.purchaseData,
});

const mapDispatchToProps = {
    ...accOpeningActions,
    ...localStateManagementActions,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withAccountManagement(EsignComponent)));
